import Vue from "vue";
var moment = require("moment-timezone");

Vue.filter("changeDateDDMMYYYY", function (value) {
  return moment(value).format("DD-MM-YYYY h:mm:ss");
});

Vue.filter("changeDateYYYYMMDD", function (value) {
  return moment(value).format("YYYY-MM-DD h:mm:ss A");
});

Vue.filter("YYYYMMDD", function (value) {
  return moment(value).format("YYYY-MM-DD");
});

Vue.filter("TIME", function (value) {
  return moment(value).format("h:mm:ss A");
});

Vue.filter("amountFormat", function (value, currency) {
  if (value === null || value === undefined || value === "") return "";

  // Custom symbol mapping for African currencies
  const customSymbols = {
    GHS: "₵",
    NGN: "₦",
    XOF: "CFA",
    XAF: "FCFA",
    KES: "KSh",
  };

  try {
    const formatted = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currency || "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);

    // Replace the currency symbol with custom symbol if available
    if (customSymbols[currency]) {
      // Extract just the number part and prepend custom symbol
      const numberPart = formatted.replace(/[^\d.,]/g, "");
      return customSymbols[currency] + " " + numberPart;
    }

    // Ensure space between currency symbol and amount for standard currencies
    return formatted.replace(/^([^\d.,]+)/, "$1 ").replace(/\s+/g, " ");
  } catch (e) {
    // fallback to plain number format with custom symbol if available
    const numberPart = new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);

    if (customSymbols[currency]) {
      return customSymbols[currency] + " " + numberPart;
    }

    return numberPart;
  }
});

Vue.filter("TRIMTEXT", function (value) {
  return value.length > 10 ? value.slice(0, 10) + "..." : value;
});
